import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// ✅ PHASE 2.1 : Enregistrer le Service Worker pour PWA
serviceWorkerRegistration.register({
  onSuccess: (registration) => {
    console.log('✅ Service Worker enregistré avec succès:', registration);
  },
  onUpdate: (registration) => {
    console.log('🔄 Nouveau Service Worker disponible:', registration);
    
    // Vérifier si un service worker est déjà en attente
    if (registration.waiting) {
      // Déclencher l'affichage de la bannière via un événement personnalisé
      window.dispatchEvent(new CustomEvent('sw-update-available', { detail: registration }));
    }
  },
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
